import { categories } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20editorial%20flatlay%20with%20designer%20sneakers%20silk%20scarf%20leather%20wallet%20and%20gold%20accessories%20on%20textured%20cream%20paper%20background%2C%20dramatic%20natural%20window%20light%2C%20warm%20beige%20and%20champagne%20palette%2C%20sophisticated%20product%20photography%2C%20elegant%20composition%2C%20high%20detail%2C%20magazine%20editorial%20quality&width=1600&height=900&seq=hero-main-v2-2026&orientation=landscape"
          alt="Sugargoo Spreadsheet fashion product showcase"
          title="Sugargoo Spreadsheet - Smart Shopping Made Simple"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-24 md:pt-28 pb-16">
        <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16">
          <div className="w-full lg:w-3/5">
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight">
              Sugargoo
              <br />
              Spreadsheet
              <br />
              <span className="text-primary-400">Smart Shopping</span>
            </h1>
            <p className="mt-6 text-base md:text-lg text-background-50/90 max-w-xl leading-relaxed">
              Your complete guide to smarter shopping with Sugargoo Spreadsheet. Browse 15+ curated product categories, discover 12 expert guides, and streamline your entire ordering workflow — all from one beautifully organized hub.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center px-7 py-3 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
              >
                sugargoo spreadsheet
                <i className="ri-arrow-right-up-line ml-2 text-lg"></i>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center px-7 py-3 border-2 border-background-50/60 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-background-50 hover:text-foreground-950 transition-all cursor-pointer whitespace-nowrap"
              >
                Buy It Now
                <i className="ri-shopping-bag-line ml-2 text-lg"></i>
              </a>
            </div>
          </div>

          <div className="hidden lg:block w-full lg:w-2/5">
            <div className="bg-background-50/10 backdrop-blur-sm rounded-2xl p-6 border border-background-50/20">
              <p className="text-sm font-semibold text-background-50/80 mb-4 uppercase tracking-wider">Browse Categories</p>
              <div className="grid grid-cols-2 gap-1.5">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="block px-3 py-2 text-sm text-background-50/90 hover:text-background-50 hover:bg-background-50/10 rounded-lg transition-all cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-background-50/50 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-background-50/70 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}